// File: src/components/about/Community.js

import React from 'react';
import styles from './Community.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { cn } from '../../utils/helpers';

const INITIATIVES = [
  {
    id: 'northern',
    tag: 'Northern Food Security',
    title: 'Supporting the Arviat Green Igloo Project',
    body: 'GreenScience donated a 1,000-pound tote of premium worm castings to assist greenhouse operations at the Arviat Green Igloo project in the Inuit community of Arviat — through a partnership with Toronto Metropolitan University. This initiative directly supports food sovereignty in one of Canada\'s most remote northern communities.',
    accent: 'accentGreen',
  },
  {
    id: 'foodbank',
    tag: 'Local Food Security',
    title: 'Local Food Bank Contributions',
    body: 'High-value vegetables grown at GreenScience\'s organic waste processing facility are donated directly to local food banks. This initiative transforms the outputs of our process into immediate, tangible community nutrition — closing the loop from waste to food.',
    accent: 'accentTeal',
  },
  {
    id: 'indigenous',
    tag: 'Indigenous Partnership',
    title: 'Chippewas of the Thames First Nation',
    body: 'GreenScience has worked with the Chippewas of the Thames First Nation to support efforts to diversify community income streams through the potential establishment of a GreenScience organic waste processing operation — creating local employment and long-term economic resilience.',
    accent: 'accentEarth',
  },
];

function Community() {
  return (
    <section className={styles.section}>
      <div className="site-container">

        {/* Header */}
        <ScrollAnimation className={styles.header}>
          <p className={styles.eyebrow}>Community Engagement</p>
          <h2 className={styles.heading}>
            Rooted in the Communities We Serve
          </h2>
          <p className={styles.subheading}>
            GreenScience recognizes that environmental progress and community
            wellbeing are inseparable. We are particularly committed to
            contributing to initiatives that benefit Indigenous Nations and
            their communities.
          </p>
        </ScrollAnimation>

        {/* Initiative cards */}
        <div className={styles.grid}>
          {INITIATIVES.map((item, i) => (
            <ScrollAnimation key={item.id} delay={i * 130} className={styles.cardWrap}>
              <div className={cn(styles.card, styles[item.accent])}>
                <div className={styles.cardInner}>
                  <span className={styles.tag}>{item.tag}</span>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardBody}>{item.body}</p>
                </div>
              </div>
            </ScrollAnimation>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Community;